import { createPopper } from "@popperjs/core";

export function addProductVariationsHandler(
  $,
  optionSlugToOrig,
  durationSlugToOrig
) {
  const variations = jQuery(".variations_form").data("product_variations");

  const optionElement = $("select#pa_options");
  const durationElement = $("select#pa_durations");
  const teacherElement = $("select#pa_teacher");

  const update = function () {
    const selectedOption = optionElement.val();
    const selectedDuration = durationElement.val();

    const selectedVariation = $.grep(
      variations,
      (e) =>
        e.attributes.attribute_pa_options === selectedOption &&
        e.attributes.attribute_pa_durations === selectedDuration
    )[0];
    const option = optionSlugToOrig[selectedOption];
    const duration = durationSlugToOrig[selectedDuration];
    const addToCartSection = $("div.woocommerce-variation-add-to-cart");
    const purchaseAutomated = $("div.purchase-automated");
    const purchaseAutomatedFreeTrial = $("div.purchase-automated-free-trial");
    const purchaseInApp = $("div.purchase-in-app");
    const purchaseEBookPlus = $("div.purchase-ebook-plus");
    const studentVouchersSection = $("div.student-vouchers");
    const schoolLicenseSection = $("div.school-license");
    const durationSection = $('table.variations tbody tr th label[for="pa_durations"]').closest('tr');
    const allSections = [
      addToCartSection,
      purchaseAutomated,
      purchaseAutomatedFreeTrial,
      purchaseInApp,
      purchaseEBookPlus,
      studentVouchersSection,
      schoolLicenseSection
    ];

    const showSection = (section) => {
      for (let sec of allSections) {
        if (sec !== section) {
          sec.attr("style", "display: none !important");
        } else {
          sec.attr("style", "display: block !important");
        }
      }
    };

    const hide = (className) => {
      $('div.woocommerce-variation-add-to-cart ' + className).hide();
      $('div.woocommerce-variation-add-to-cart ' + className + " + div").text("Anzahl");
      $('div.woocommerce-variation-add-to-cart ' + className + " input").removeAttr("required");
    };
    const show = (className) => {
      $('div.woocommerce-variation-add-to-cart ' + className).show();
      $('div.woocommerce-variation-add-to-cart ' + className + " + div").text("Anzahl Plätze");
      $('div.woocommerce-variation-add-to-cart ' + className + " input").prop("required", true);
    };

    if(duration === 'unlimited') {
	optionElement.val('in_app')
	teacherElement.val('student')
    }

    if ((option === "invoice-de" || option === "invoice") && (duration === "1mo" || duration === "1mo-de")) {
      const freeTrial =
        selectedVariation != null &&
        selectedVariation.display_price === 0 &&
        (duration === "1mo" || duration === "1mo-de");
      if (freeTrial) {
        showSection(purchaseAutomatedFreeTrial);
        durationSection.find("th.label, select, ul").show();
      } else {
        showSection(purchaseAutomated);
        durationSection.find("th.label, select, ul").show();
      }
    } else if (option === "in_app" || option === "in_app-de") {
      showSection(addToCartSection);
      durationSection.find("th.label, select, ul").show();
      hide('.esq-class-name-wrapper');
    } else if (option === "ebook_plus" || option === "ebook_plus-de") {
      showSection(purchaseEBookPlus);
      durationSection.find("th.label, select, ul").show();
    } else if (option === "student_vouchers" || option === "student_vouchers-de") {
      showSection(studentVouchersSection);
      durationSection.find("th.label, select, ul").show();
    } else if (option === "invoice" || option === "invoice-de") {
      showSection(addToCartSection);
      show('.esq-class-name-wrapper');
      durationSection.find("th.label, select, ul").show();
    } else if (option === 'schoollicense' || option === "schoollicense-de") {
      showSection(schoolLicenseSection);
      // durationSection.hide(); // Hide the row containing durations
      durationSection.find("th.label, select, ul").hide(); // Hide the th, select, and ul elements
    } else {
      showSection(undefined);
      durationSection.find("th.label, select, ul").show(); // Show the row containing durations for other options
    }
  };

  optionElement.change(update);
  durationElement.change(update);
  update();
}

// Logic for the EventOn Copy of Link

export function eventOnLinkOnClickHandler(e) {
  copyLinkUrlToClipboardWithFeedback(e.target.closest("a"));
  e.preventDefault();
}

function copyLinkUrlToClipboardWithFeedback(el) {
  let href = el.getAttribute("href");
  copyTextToClipboard(href);

  let tooltip = document.createElement("div");
  tooltip.className = "esq-shop-tooltip";
  document.body.appendChild(tooltip);
  let feedbackMessage = el.getAttribute("data-copy-feedback");
  tooltip.innerText = feedbackMessage;
  let popper = createPopper(el, tooltip);

  setTimeout(() => {
    popper.destroy();
    tooltip.parentNode.removeChild(tooltip);
  }, 1000);
}

function copyTextToClipboard(text) {
  let input = document.createElement("textarea");
  input.style.position = "fixed";
  input.style.opacity = "0";
  input.style.width = 0;
  input.style.height = 0;
  input.value = text;
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);
}
